export default __webpack_public_path__ + "static/course-d566630b7f837c0812e37e53a15de693.mp4";